import React, { MouseEvent } from 'react'
import styled, { css } from 'styled-components'

import color from '../../designTokens/color'

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  color: 'primary' | 'secondary' | 'tertiary' | 'action'
  size: 'large' | 'medium' | 'small'
  children: React.ReactNode
  disabled?: boolean
  title?: string
  className?: string
  'aria-label'?: string
  onClick?: (e: MouseEvent) => void
}

// TODO: action color는 size가 small일 때만 사용가능하다. 이에 대한 에러처리 하기
const Button: React.FC<Props> = ({
  children,
  onClick,
  color,
  size,
  disabled = false,
  title,
  'aria-label': ariaLabel = '',
  className,
  ...htmlDefaultProps
}) => {
  return (
    <StyledButton
      aria-label={ariaLabel}
      color={color}
      size={size}
      disabled={disabled}
      onClick={onClick}
      className={className}
      {...(title && { title })}
      {...htmlDefaultProps}
    >
      {children}
    </StyledButton>
  )
}

const StyledButton = styled.button<Props>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-style: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;

  ${(props) => {
    switch (props.color) {
      case 'primary':
        return css`
          background-color: #ff540f;
          color: #ffffff;
        `
      case 'secondary':
        return css`
          background-color: #ffede3;
          color: #ff540f;
        `
      case 'tertiary':
        return css`
          background-color: #f5f5f5;
          color: #000000;
        `
      case 'action':
        return css`
          background-color: ${color.white};
          color: ${color.black};
          border: 1px solid ${color.gray400};
        `
    }
  }}
  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          padding: 14px 16px;
          font-size: 16px;
        `
      case 'medium':
        return css`
          padding: 8px 16px;
          font-size: 14px;
        `
      case 'small':
        return css`
          padding: 8px 16px;
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        `
    }
  }}
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #f5f5f5;
      color: #999999;
    `}
`

export default Button
